import { cx } from '@/lib/cx';
import styles from './SeaArc.module.css';

export interface SeaArcProps {
  className?: string;
}

/**
 * SEPARADOR CURVO DEL HERO DE CANCÚN — el rasgo firma de la página.
 *
 * Es UNA sola curva tendida. No se usa `CurveDivider` del substrato porque su
 * trazado es la ese de dos vientres del hub; aquí una ese rompería la
 * solemnidad del arco. Pedido a FORGE-ALPHA como variante parametrizable
 * (PAGE_CONTRACT §10); mientras, vive en la página.
 *
 * EL TRAZADO ESTÁ MEDIDO SOBRE EL PÓSTER, no elegido. Barriendo el filete
 * dorado columna a columna en `DEMO_5_CancunVIP.png` sale este perfil (px del
 * póster de 1024): extremo izquierdo y=575 · x=256 y=627 · x=512 y=651 ·
 * **punto más bajo y=652 en x=576** · x=768 y=644 · extremo derecho y=602.
 * De ahí dos hechos que el trazado anterior no recogía:
 *
 *  1. **La sagitta es de 63 px sobre 1024 (6,2 % del ancho)**, no de 50. El
 *     comentario anterior decía "~50 px medidos" y la geometría entregaba
 *     exactamente eso: un arco un escalón más plano que el del póster. El de
 *     México es el arco discreto (~25 px); éste es el marcado.
 *  2. **El arco NO es simétrico.** Su extremo derecho cae 27 px por debajo del
 *     izquierdo y el vientre está corrido a la derecha del eje (x=576 de 1024,
 *     o sea el 56 %). Un `Q` centrado no puede dar ninguna de las dos cosas.
 *
 * El `viewBox` es de 100 de alto para que 1 unidad ≈ 1 % del alto de la caja y
 * las cifras de arriba se lean directamente. `preserveAspectRatio="none"` y
 * `vector-effect: non-scaling-stroke` mantienen el filete fino al estirar.
 */
export function SeaArc({ className }: SeaArcProps) {
  // Extremos a 3 y 33 (los 27 px de desnivel medidos) y vientre en ~88, que con
  // el alto de `.arc` a 1024 px de viewport da los 63 px de sagitta del póster.
  const curva = 'M0 3 C 520 112, 1120 108, 1440 33';

  return (
    <svg
      className={cx(styles.arc, className)}
      viewBox="0 0 1440 100"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path className={styles.body} d={`${curva} L1440 100 L0 100 Z`} />
      <path className={styles.edge} d={curva} />
    </svg>
  );
}
